/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { components } from 'react-select';
import { SELECT_DROPDOWN_SELECT_ALL_VALUE } from '../../constants';
import areMultiProps from '../../helpers/areMultiProps';
import { OptionWithCheckbox } from './OptionWithCheckbox';
import { OptionWithDescription } from './OptionWithDescription';
import { SelectAllOption } from './SelectAllOption';
export function Option(props) {
    const { value } = props.data;
    if (areMultiProps(props)) {
        if (value === SELECT_DROPDOWN_SELECT_ALL_VALUE) {
            return React.createElement(SelectAllOption, Object.assign({}, props));
        }
        if (props.selectProps.rootProps.withCheckboxes) {
            return React.createElement(OptionWithCheckbox, Object.assign({}, props));
        }
    }
    if (props.selectProps.rootProps.withDescriptions) {
        return React.createElement(OptionWithDescription, Object.assign({}, props));
    }
    return React.createElement(components.Option, Object.assign({}, props));
}
//# sourceMappingURL=Option.js.map